import _ from 'lodash';
import { converter } from 'helpers/converter';

const UAVendor = /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i;
const VALID_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const emailRegex = /^[A-Z0-9._%+\-&,´'\s]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const isValidEmail = email => email !== null && VALID_EMAIL.test(email);

export const getFormErrors = (codeError, translations, errorsPlaceholder) => {
  const errorMsg = converter.convertApa(translations, codeError);

  const predicate = code => code === codeError;
  return _.flow(
    placeholders =>
      _.reduce(
        placeholders,
        (errors, placeholder, key) => ({
          ...errors,
          [key]: _.some(placeholder, predicate),
        }),
        {},
      ),
    _.pickBy,
    errors =>
      _.reduce(
        errors,
        (last, error, key) => ({
          ...last,
          [key]: { error, errorMsg, value: '' },
        }),
        {},
      ),
  )(errorsPlaceholder);
};

export const getUserAgent = () => {
  const ua = navigator.userAgent;
  let tem;

  let M = ua.match(UAVendor) || [];

  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return ['IE ', tem[1] || ''];
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) {
      return tem
        .slice(1)
        .join(' ')
        .replace('OPR', 'Opera')
        .split(' ');
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  // eslint-disable-next-line no-cond-assign
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return M;
};
